import { Typography, Box, Container } from '@mui/material';
import { FaUser } from 'react-icons/fa';
import { motion } from 'framer-motion';
import profile from '../data/profile';

function AboutSection() {
  const { bio } = profile;

  if (!bio || bio.length === 0) return null;

  const aboutText = bio[0] || '';

  return (
    <Box id="about" component="section" sx={{ py: { xs: 4, sm: 5.5, md: 7 }, background: 'rgba(20,18,16,0.45)' }}>
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55, ease: 'easeOut' }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: { xs: 2.5, md: 3 } }}>
            <Box sx={{ width: 3, height: 22, backgroundColor: '#C4785D', borderRadius: 2, flexShrink: 0 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
              <FaUser size={17} color="#877D72" />
              <Typography variant="h5" component="h2" sx={{ fontSize: { xs: '1.3rem', md: '1.4rem' }, color: '#EAE3D6', fontWeight: 600, letterSpacing: '-0.015em' }}>
                About
              </Typography>
            </Box>
          </Box>

          <Typography sx={{ fontSize: { xs: '0.97rem', md: '1.05rem' }, lineHeight: 1.85, color: '#877D72', mb: 1.75 }}>
            {aboutText}
          </Typography>

          <Typography sx={{ fontSize: { xs: '0.88rem', md: '0.93rem' }, color: '#524A42', lineHeight: 1.7 }}>
            Beyond work — F1 · Soccer · Guitar · Video game tech · GPUs
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
}

export default AboutSection;
